__turbopack_context__.v({
  "icon": "assessedTake-module-scss-module__oghsYW__icon",
  "tooltip": "assessedTake-module-scss-module__oghsYW__tooltip",
  "tooltiptext": "assessedTake-module-scss-module__oghsYW__tooltiptext",
  "tooltiptextLeft": "assessedTake-module-scss-module__oghsYW__tooltiptextLeft",
});
